import { reportError } from "helpers/error-reporting";
import createAuthClient from "helpers/auth-client";

const authClient = createAuthClient();

/* global APPCUES_CONTENT_API_URL */

export const getContentApiHeaders = async () => {
  const currentCustomToken = await authClient.getToken();
  return {
    Authorization: `Bearer ${currentCustomToken}`,
    "Content-Type": "application/json"
  };
};

export const getContentApiPostPromise = async (actionType, data) => {
  const requestHeaders = await getContentApiHeaders();
  const response = await fetch(
    `${APPCUES_CONTENT_API_URL}/contents/${actionType}`,
    {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify(data)
    }
  );

  const responseData = await response.json();

  if (response.status === 200) {
    return Promise.resolve(responseData);
  }
  return Promise.reject(new Error(responseData));
};

export const createProductLedFlow = async data => {
  const requestHeaders = await getContentApiHeaders();
  const response = await fetch(
    `${APPCUES_CONTENT_API_URL}/default-content/product-led-flows/`,
    {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify(data)
    }
  );

  const responseData = await response.json();

  if (response.status === 200) {
    return Promise.resolve(responseData);
  }
  return Promise.reject(new Error(responseData));
};

/**
 * Hits content api to create the default lifecycle segments in the
 * user's account
 * @param  {Obj} data - account_id
 *                    - account_api_key
 * @return {Promise<Obj>}      Resolves with {data {segments: [ ]}}
 */
export const createLifecycleSegments = async data => {
  const requestHeaders = await getContentApiHeaders();
  const response = await fetch(
    `${APPCUES_CONTENT_API_URL}/default-content/product-led-segments/`,
    {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify(data)
    }
  );

  const responseData = await response.json();
  if (response.status === 200) {
    if (
      typeof responseData !== "object" ||
      typeof responseData.data !== "object" ||
      typeof responseData.data.segments !== "object" ||
      typeof responseData.data.segments.length !== "number"
    ) {
      throw new TypeError(
        "Invalid response data returned by content api product-led-segments endpoint"
      );
    }
    return Promise.resolve(responseData);
  }
  return Promise.reject(new Error(responseData.message));
};

export const createTestFlow = (
  contentType,
  stepId,
  accountApiKey,
  accountId
) => {
  return Promise.race([
    getContentApiPostPromise("test", {
      content_type: contentType,
      content_id: stepId,
      account_api_key: accountApiKey,
      account_id: accountId
    }),
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const message = "createTestFlow request timed out";
        reportError(message, {
          contentType,
          stepId,
          accountApiKey,
          accountId
        });
        reject(new Error(message));
      }, 10000);
    })
  ]);
};

export const getTestFlowUrl = (accountId, draftFlowId) => {
  if (!accountId || !draftFlowId) {
    reportError("Invalid accountId or draftFlowId passed to getTestFlowUrl");
    return undefined;
  }

  /* global APPCUES_TEST_MODE_LAMBDA_URL */
  return `${APPCUES_TEST_MODE_LAMBDA_URL}?accountId=${accountId}&draftFlowId=${draftFlowId}`;
};

export default {
  getContentApiHeaders,
  getContentApiPostPromise,
  createProductLedFlow,
  createLifecycleSegments,
  createTestFlow,
  getTestFlowUrl
};
